import {
  IonList,
  IonListHeader,
  IonButton,
  IonIcon,
  IonText,
  IonContent,
  IonPopover,
  IonItem,
  useIonToast,
  useIonAlert,
  IonModal,
} from "@ionic/react";
import {
  ellipsisVerticalOutline,
  personAddOutline,
  businessOutline,
  addSharp,
  trashOutline,
} from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { addQuestionToList } from "../../../store/templateDetail";
import { deleteTemplate } from "../../../store/templateDetail/actions/deleteTemplate";
import { selectQuestionList } from "../../../store/templateDetail/selectors/selectQuestionList";
import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
import { findTemplatesForUserOrLocation } from "../../../store/templateList/actions/findTemplatesForUserOrLocation";

export const HelperActions: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const listLength = useSelector(selectQuestionList).length;
  const template = useSelector(selectTemplateDetail);
  const [presentToast, hideToast] = useIonToast();
  const [present] = useIonAlert();
  const history = useHistory();
  const { id }: { id: string } = useParams();

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const handleDeleteTemplate = async () => {
    try {
      presentToast({
        message: `Eliminando plantilla...`,
        color: "primary",
      });
      const {
        payload: { success },
      }: any = await dispatch(deleteTemplate());
      if (!success) {
        throw new Error("No se envió la notificación");
      }
      await hideToast();
      presentToast({
        message: `Se elimino la plantilla.`,
        color: "success",
        duration: 2000,
      });
      await dispatch(findTemplatesForUserOrLocation());
      return history.replace("/app/tic/plantillas-file");
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema eliminando la plantilla.",
        color: "danger",
        duration: 2000,
      });
    }
  };

  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        <IonText>Acciones</IonText>
        <IonIcon icon={ellipsisVerticalOutline} slot="end"></IonIcon>
      </IonButton>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <IonText>Acciones</IonText>
            </IonListHeader>
            {template.assignedTo === "user" && (
              <IonItem
                routerLink={`/app/tic/plantillas-file/asigna-usuarios/${template.id}`}
                lines="none"
                onClick={() => {
                  // setShowPopover({ showPopover: false, event: undefined });
                  setShowModal(false);
                }}
              >
                <IonIcon icon={personAddOutline} />
                <IonText class="ion-padding-start">Asignar usuarios</IonText>
              </IonItem>
            )}

            {template.assignedTo === "location" && (
              <IonItem
                routerLink={`/app/tic/plantillas-file/asigna-instalaciones/${template.id}`}
                lines="none"
                onClick={() => {
                  // setShowPopover({ showPopover: false, event: undefined });
                  setShowModal(false);
                }}
              >
                <IonIcon icon={businessOutline} />
                <IonText class="ion-padding-start">Asignar instalaciones</IonText>
              </IonItem>
            )}

            <IonItem
              lines="none"
              onClick={() => {
                dispatch(addQuestionToList({ order: listLength + 1, type: "file" }));
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
              }}
            >
              <IonIcon icon={addSharp} />
              <IonText class="ion-padding-start">Agregar documento</IonText>
            </IonItem>
            <IonItem
              lines="none"
              onClick={() => {
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
                present({
                  header: `¿Deseas eliminar esta plantilla?`,
                  buttons: [
                    "No",
                    {
                      text: "Eliminar plantilla",
                      handler: () => handleDeleteTemplate(),
                    },
                  ],
                });
              }}
            >
              <IonIcon color="danger" icon={trashOutline} />
              <IonText color="danger" class="ion-padding-start">
                Eliminar plantilla
              </IonText>
            </IonItem>
          </IonList>
        </IonContent>
      </IonModal>

      {/* <IonButton
                id="size-button"
                onClick={(e: any) => {
                    e.persist();
                    setShowPopover({ showPopover: true, event: e });
                }}
            >
                <IonText>Acciones</IonText>
                <IonIcon icon={ellipsisVerticalOutline} slot="end"></IonIcon>
            </IonButton>
            <IonPopover
                event={popoverState.event}
                isOpen={popoverState.showPopover}
                onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
            >
                <IonContent>
                    <IonList>
                        <IonListHeader>
                            <IonText>Acciones</IonText>
                        </IonListHeader>
                        {template.assignedTo === "user" &&
                            <IonItem
                                routerLink={`/app/tic/plantillas-file/asigna-usuarios/${template.id}`}
                                lines="none"
                                onClick={() => {
                                    setShowPopover({ showPopover: false, event: undefined });
                                }}
                            >
                                <IonIcon icon={personAddOutline} />
                                <IonText class="ion-padding-start">Asignar usuarios</IonText>
                            </IonItem>}

                        {template.assignedTo === "location" &&
                            <IonItem
                                routerLink={`/app/tic/plantillas-file/asigna-instalaciones/${template.id}`}
                                lines="none"
                                onClick={() => {
                                    setShowPopover({ showPopover: false, event: undefined });
                                }}
                            >
                                <IonIcon icon={businessOutline} />
                                <IonText class="ion-padding-start">Asignar instalaciones</IonText>
                            </IonItem>}

                        <IonItem
                            lines="none"
                            onClick={() => {
                                dispatch(addQuestionToList({ order: listLength + 1, type: "file" }))
                                setShowPopover({ showPopover: false, event: undefined });
                            }}
                        >
                            <IonIcon icon={addSharp} />
                            <IonText class="ion-padding-start">Agregar documento</IonText>
                        </IonItem>
                        <IonItem
                            lines="none"
                            onClick={() => {
                                setShowPopover({ showPopover: false, event: undefined });
                                present({
                                    header: `¿Deseas eliminar esta plantilla?`,
                                    buttons: [
                                      "No",
                                      {
                                        text: "Eliminar plantilla",
                                        handler: () => handleDeleteTemplate(),
                                      },
                                    ],
                                  });
                            }}
                        >
                            <IonIcon color="danger" icon={trashOutline} />
                            <IonText color="danger" class="ion-padding-start">Eliminar plantilla</IonText>
                        </IonItem>
                    </IonList>
                </IonContent>
            </IonPopover> */}
    </>
  );
};
